// import React from "react";
// import ProductCard from "./ProductCard";

// const ProductGrid = ({ products, cart, onChangeQuantity, language }) => {
//   return (
//     <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-7">
//       {products.map((product) => {
//         const cartItem = cart.find((x) => x.id === product.id);

//         return (
//           <ProductCard
//             key={product.id}
//             product={product}
//             quantity={cartItem?.quantity || 0}
//             onChangeQuantity={onChangeQuantity}
//             language={language}
//           />
//         );
//       })}
//     </div>
//   );
// };

// export default ProductGrid;   
import React, { useMemo, useState } from "react";
import ProductCard from "./ProductCard";

const MAIN_COLOR = "rgb(29, 71, 127)";

const TEXTS = {
  tr: {
    subscriptionPackages: "Abonelik Seçenekleri",
    subscriptionDesc: "İhtiyacınıza uygun abonelik paketini seçebilirsiniz.",
    monthly: "Aylık",
    yearly: "Yıllık",
    twoMonthsFree: "Yıllık Abonelikte 2 Ay Ücretsiz!",
    changeAnytime: "Paketinizi istediğiniz zaman değiştirebilirsiniz",
    creditPackages: "Ek Kontör Fiyat Listesi",
    creditDesc: "Ek kontör satın alabilirsiniz.",
    contactForMoreCredits:
      "Daha fazla kontör seçenekleri için iletişime geçin!",
  },
  en: {
    subscriptionPackages: "Subscription Options",
    subscriptionDesc: "Choose the subscription package that suits your needs.",
    monthly: "Monthly",
    yearly: "Yearly",
    twoMonthsFree: "2 Months Free with Annual Subscription!",
    changeAnytime: "You can change your package anytime",
    creditPackages: "Additional Credit Price List",
    creditDesc: "You can buy additional credits.",
    contactForMoreCredits: "Contact us for more credit options!",
  },
  de: {
    subscriptionPackages: "Abonnementoptionen",
    subscriptionDesc: "Wählen Sie das passende Abonnementpaket.",
    monthly: "Monatlich",
    yearly: "Jährlich",
    twoMonthsFree: "2 Monate kostenlos beim Jahresabonnement!",
    changeAnytime: "Sie können Ihr Paket jederzeit ändern",
    creditPackages: "Preisliste für zusätzliche Kontingente",
    creditDesc: "Sie können zusätzliche Kontingente kaufen.",
    contactForMoreCredits:
      "Kontaktieren Sie uns für weitere Kontingentoptionen!",
  },
  fr: {
    subscriptionPackages: "Options d'abonnement",
    subscriptionDesc: "Choisissez le forfait adapté à vos besoins.",
    monthly: "Mensuel",
    yearly: "Annuel",
    twoMonthsFree: "2 mois gratuits avec l’abonnement annuel !",
    changeAnytime: "Vous pouvez modifier votre forfait à tout moment",
    creditPackages: "Liste des prix des crédits supplémentaires",
    creditDesc: "Vous pouvez acheter des crédits supplémentaires.",
    contactForMoreCredits:
      "Contactez-nous pour plus d'options de crédits !",
  },
  nl: {
    subscriptionPackages: "Abonnementsopties",
    subscriptionDesc: "Kies het abonnement dat bij u past.",
    monthly: "Maandelijks",
    yearly: "Jaarlijks",
    twoMonthsFree: "2 maanden gratis bij een jaarabonnement!",
    changeAnytime: "U kunt uw pakket op elk moment wijzigen",
    creditPackages: "Prijslijst voor extra credits",
    creditDesc: "U kunt extra credits kopen.",
    contactForMoreCredits: "Neem contact met ons op voor meer creditopties!",
  },
};

const ProductGrid = ({ products, cart, onChangeQuantity, language }) => {
  const [subscriptionType, setSubscriptionType] = useState("AM");

  const langKey = String(language || "tr")
    .toLowerCase()
    .replace("_", "-")
    .trim()
    .slice(0, 2);

  const text = TEXTS[langKey] || TEXTS.tr;

  const subscriptionProducts = useMemo(() => {
    return products.filter((product) => product.priceType === subscriptionType);
  }, [products, subscriptionType]);

  const creditProducts = useMemo(() => {
    return products.filter((product) => product.priceType === "Q");
  }, [products]);

  const selectedSubscription = useMemo(() => {
    return cart.find(
      (item) => item.priceType === "AM" || item.priceType === "AY"
    );
  }, [cart]);

  const getQuantity = (product) => {
    return (
      cart.find((x) => x.code === product.code || x.id === product.id)
        ?.quantity || 0
    );
  };

  const handleSubscriptionTypeChange = (nextType) => {
    setSubscriptionType(nextType);

    if (!selectedSubscription) return;
    if (selectedSubscription.priceType === nextType) return;

    onChangeQuantity(selectedSubscription, "decrease");
  };

  return (
    <div>
      <div className="relative mb-5 flex min-h-[56px] flex-col gap-3 lg:flex-row lg:items-start">
        <div>
          <h2 className="text-lg font-bold" style={{ color: MAIN_COLOR }}>
            {text.subscriptionPackages}
          </h2>
          <p className="mt-1 text-sm text-slate-600">
            {text.subscriptionDesc}
          </p>
        </div>

        <div className="order-3 self-center lg:absolute lg:left-1/2 lg:top-0 lg:order-none lg:-translate-x-1/2">
          <div className="flex rounded-2xl border border-slate-200 bg-white p-1 shadow-sm">
            <button
              type="button"
              onClick={() => handleSubscriptionTypeChange("AM")}
              className="h-10 rounded-xl px-6 text-sm font-semibold sm:px-7"
              style={{
                backgroundColor:
                  subscriptionType === "AM" ? MAIN_COLOR : "transparent",
                color: subscriptionType === "AM" ? "white" : MAIN_COLOR,
              }}
            >
              {text.monthly}
            </button>

            <button
              type="button"
              onClick={() => handleSubscriptionTypeChange("AY")}
              className="h-10 rounded-xl px-6 text-sm font-semibold sm:px-7"
              style={{
                backgroundColor:
                  subscriptionType === "AY" ? MAIN_COLOR : "transparent",
                color: subscriptionType === "AY" ? "white" : MAIN_COLOR,
              }}
            >
              {text.yearly}
            </button>
          </div>
        </div>

        <div className="order-2 text-left lg:order-none lg:ml-auto lg:text-right">
          <div className="text-sm font-bold" style={{ color: MAIN_COLOR }}>
            {text.twoMonthsFree}
          </div>
          <div className="mt-1 text-xs text-slate-600">
            {text.changeAnytime}
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
        {subscriptionProducts.map((product) => (
          <ProductCard
            key={product.id}
            product={product}
            quantity={getQuantity(product)}
            onChangeQuantity={onChangeQuantity}
            language={language}
          />
        ))}
      </div>

      {creditProducts.length > 0 && (
        <>
          <div className="mb-4 mt-7">
            <h2 className="text-lg font-bold" style={{ color: MAIN_COLOR }}>
              {text.creditPackages}
            </h2>
            <p className="mt-1 text-sm text-slate-600">{text.creditDesc}</p>
          </div>

          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-5 2xl:grid-cols-7">
            {creditProducts.map((product) => (
              <ProductCard
                key={product.id}
                product={product}
                quantity={getQuantity(product)}
                onChangeQuantity={onChangeQuantity}
                language={language}
              />
            ))}
          </div>

          <div
            className="mt-8 mb-4 text-lg font-semibold"
            style={{ color: MAIN_COLOR }}
          >
            {text.contactForMoreCredits}
          </div>
        </>
      )}
    </div>
  );
};

export default ProductGrid;